module.exports = __webpack_public_path__ + "static/gallery-2-b008b5777280862d8afd18082f21456c.jpg";